import { User } from "../../types";

/**
 * What a clinic admin sends to add a therapist. There is no password field on purpose:
 * this is an invitation, not an account creation. The server either makes an unclaimed
 * account and emails a link, or -- if the address already works somewhere else on the
 * platform -- adds a membership and leaves the existing password alone.
 *
 * `role` is fixed: the API accepts only THERAPIST here. Clinic administrators are
 * appointed by the platform owner, and patients go through their own endpoint.
 */
export interface InviteTherapistRequest {
    emailAddress: string;
    firstName?: string;
    lastName?: string;
    role: 'THERAPIST';
}

/** What the invite form holds. Blank optional fields are dropped rather than sent as "". */
export interface InviteTherapistFormValues {
    emailAddress: string;
    firstName: string;
    lastName: string;
}

export const toInviteTherapistRequest = (values: InviteTherapistFormValues): InviteTherapistRequest => ({
    emailAddress: values.emailAddress.trim(),
    firstName: values.firstName.trim() || undefined,
    lastName: values.lastName.trim() || undefined,
    role: 'THERAPIST',
});

/**
 * The account the invitation landed on. Deliberately narrow -- it says nothing about the
 * membership, which is still inactive until the invitation is accepted, so the list has
 * to be refetched rather than updated from this.
 */
export type InvitedUser = User;
